import { cardContainerStyles } from "@insite/content-library/Components/CardContainer";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

Object.assign(cardContainerStyles, {
    cardDivider: {
        css: css`
            width: 100%;
        `,
    },
});
